/**
 * 全局组件注册
 */
// SvgIcon 图标组件
import SvgIcon from '@/components/SvgIcon/index.vue'

// 空数据占位图组件
import Empty from '@/components/Empty/index.vue'

// Loading 加载动画组件
import Loading from '@/components/Loading/index.vue'

import NoteDialog from '@/components/NoteDialog/index.vue'

const components = {
  SvgIcon,
  Empty,
  Loading,
  NoteDialog,
}

export default {
  install(Vue) {
    Object.keys(components).forEach((key) => {
      Vue.component(key, components[key])
    })
  },
}
